module.exports = __webpack_public_path__ + "static/locked-project-desktop-1fd4fd3ad5ec24c0cc3b98268372d00d.png";